import moment from "moment";
import { useEffect, useState } from "react";

// eslint-disable-next-line
import {
  getDiscordActiveMembersOverTime,
  getDiscordActiveMembersOverTimeByWeek,
} from "../../lib/discordQueries";
// eslint-disable-next-line import/extensions
import { ActiveMembersOverTimeRpc } from "../../lib/discordTypes";
import { getSupaClient } from "../../lib/supabase";
// eslint-disable-next-line import/extensions
import TimePeriod from "./types";

const defaultTimeFormat = "MM/DD/YY";

/**
 * Fetches Discord active members over a time period
 *
 * @param startTime - start time
 * @param endTime - end time
 * @param guildId - Discord guild id
 * @param timePeriod - the unit of time the active members are grouped by. Can be TimePeriod.Days or TimePeriod.Week
 * @returns An object with to keys --> activeMemberMetrics: An array with the Discord active members gruped by time period. loading: true when fetching data, false when done
 */
const useActiveMemberMetrics = (
  startTime: string,
  endTime: string,
  guildId: string | null,
  timePeriod: TimePeriod = TimePeriod.Days
) => {
  const [activeMemberMetrics, setActiveMemberMetrics] = useState<
    ActiveMembersOverTimeRpc[] | null
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const supabase = getSupaClient();
  const workspaceId: string =
    JSON.parse(localStorage.getItem("supabase.auth.token") || "{}")
      ?.currentSession.user?.app_metadata.workspace || "";

  // Gets Discord active members over time grupued by day or week
  const loadMetrics = async (
    // eslint-disable-next-line
    startTime: string,
    // eslint-disable-next-line
    endTime: string
  ): Promise<void | null> => {
    setLoading(true);
    if (!workspaceId) {
      setActiveMemberMetrics([]);
      setLoading(false);
      return;
    }
    // If timePeriod = days, call days rpc.
    // Otherwise, call week rpc
    const params = {
      start_time: moment(startTime).format(defaultTimeFormat),
      end_time: moment(endTime).format(defaultTimeFormat),
      guild_id: guildId,
      workspace: workspaceId,
    };
    if (timePeriod === "days") {
      const data = await getDiscordActiveMembersOverTime(
        params.start_time,
        params.end_time,
        params.guild_id,
        params.workspace
      );
      setActiveMemberMetrics(data);
      setLoading(false);
    }
    if (timePeriod === "week") {
      const data = await getDiscordActiveMembersOverTimeByWeek(
        params.start_time,
        params.end_time,
        params.guild_id,
        params.workspace
      );
      setActiveMemberMetrics(data);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMetrics(startTime, endTime);
  }, [startTime, endTime, timePeriod]);

  return { activeMemberMetrics, loading };
};

export default useActiveMemberMetrics;
